import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMathworksComponent } from './simple-icons-mathworks.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMathworksComponent ],
    exports:      [ SimpleIconsMathworksComponent ],
    bootstrap:    []
})
export class SimpleIconsMathworksModule {}
